module.exports = __webpack_public_path__ + "static/media/ly.e707148f.svg";